/**
 * The operator scope, reactively (UI overhaul PR-2).
 *
 * `currentOperatorScope()` reads the localStorage mirror synchronously; a
 * component that keys its cache entries on it must also RE-RENDER when the
 * scope changes, or a header-mounted reader (the health control, the
 * pending tray) would keep observing the old scope's entry while its
 * requests already carry the new header. The scope switcher writes the
 * mirror and dispatches `adbetter.profiles.changed` for the same tab
 * (lib/usePortfolioScope.ts); the native `storage` event covers other tabs.
 */
import { useSyncExternalStore } from 'react'
import { currentOperatorScope } from '../operatorScope'

const CHANGE_EVENT = 'adbetter.profiles.changed'

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {}
  window.addEventListener('storage', onChange)
  window.addEventListener(CHANGE_EVENT, onChange)
  return () => {
    window.removeEventListener('storage', onChange)
    window.removeEventListener(CHANGE_EVENT, onChange)
  }
}

const serverScope = (): string => 'all'

/** The scope token in force ('all' | 'mine' | '<slug>'), re-rendering on change. */
export function useOperatorScope(): string {
  return useSyncExternalStore(subscribe, currentOperatorScope, serverScope)
}
